import {
  Heading_1 as Heading1,
  Heading_4 as Heading4,
} from '@huggg/react-components';
import dictionary from 'config/dictionary';
import React from 'react';
import styles from './prepaidCard.module.scss';

const CancelledCard = () => {
  return (
    <div className={styles.cancelledCardContainer}>
      <Heading1 className={styles.cancelledCardHeader}>
        {dictionary.prepaidCards.errors.cancelledHeading}
      </Heading1>
      <Heading4>{dictionary.prepaidCards.errors.cancelledBody}</Heading4>
    </div>
  );
};

CancelledCard.propTypes = {};

export default CancelledCard;
